<section *ngIf="breadcrumbs.length > 0" class="section-container">
    <div class="section-content">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a (click)="handleGaEvent()" [routerLink]="['/portal']"><mat-icon class="mat-18">home</mat-icon></a>
                    <span class="breadcrumb-separator">&gt;</span>
                </li>
                <ng-container *ngFor="let breadcrumb of breadcrumbs; let isLast = last">
                    <li class="breadcrumb-item" *ngIf="!isLast">
                        <p>{{ breadcrumb.label }}</p>
                        <span class="breadcrumb-separator">&gt;</span>
                    </li>
                    <li class="breadcrumb-item active" *ngIf="isLast" aria-current="page">
                        {{ breadcrumb.label }}
                    </li>
                </ng-container>
            </ol>
        </nav>
    </div>
       
</section>
